import React from 'react';

/**
 * Shoe icon used by the Sko Level 1 row.
 * Sized by CSS; fill inherits via the global currentColor rule.
 */
const IconShoe = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    role="presentation"
    aria-hidden="true"
    {...props}
  >
    <path d="m14.15 10.446-3.447-.777-7.457-7.458a.54.54 0 0 0-.781.017C.978 3.853.16 5.905.16 8v4.866c0 .597.484 1.082 1.081 1.082h2.163c.597 0 1.082-.485 1.082-1.082V9.56a7.6 7.6 0 0 1 3.237 3.72c.165.406.562.671 1.002.669h6.034c.597 0 1.081-.485 1.081-1.082v-.32a2.144 2.144 0 0 0-1.69-2.1Zm-10.746 2.42H1.241V8.56c.741.053 1.47.215 2.163.482Zm11.355 0H8.722a8.675 8.675 0 0 0-3.127-3.883A8.577 8.577 0 0 0 1.26 7.478 7.48 7.48 0 0 1 2.895 3.39l7.156 7.156a.54.54 0 0 0 .263.145l3.598.811c.495.105.848.543.847 1.048Z" />
  </svg>
);

export default IconShoe;
